import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Layout for the dashboard view
 */
const GridLayout = (props) => {

    const className = classnames('grid-layout', {
        'grid-layout--desktop': props.gridName === "desktop",
        'grid-layout--mobile': props.gridName === "mobile"
    });

    return (
        <div className={className}>
            {props.children}
            <div className="u-clearer"></div>
        </div>
    )
};

GridLayout.propTypes = {

    /**
     * the name of the grid layout
     */
    gridName: PropTypes.oneOf(
        ["desktop", "mobile"]
    ).isRequired,

    /**
     * this should be one or more <GridContainer />
     */
    children: PropTypes.node
};

export default GridLayout;